module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Ingyenes Pörgetések","track":"Free Spins"}}